import Privacy from "../layout/Privacy/Privacy";

function PrivacyPage() {
  return <Privacy />;
}

export default PrivacyPage;
